import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'db-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})

export class ButtonComponent implements OnInit {
  @Input() buttonTypeClass: string;
  @Input() buttonType: string;
  @Input() disabled: boolean;
  @Input() label: any;
  @Input() data: any;

  @Output() buttonClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    if (this.buttonType === undefined) {
      this.buttonType = 'button';
    }
  }

  buttonClicked($event) {
    this.buttonClick.emit($event);
  }

}
